import KendoTreeViewMixin from './KendoTreeViewMixin'

export default {
    name: 'kendo-treeview',
    mixins: [ KendoTreeViewMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/index.js